import { Form, useActionData, useNavigation } from 'react-router-dom';

import classes from './CreateAccount.module.css';

function CreateAccount() {
  const data = useActionData();
  const navigation = useNavigation();
  const isSubmitting = navigation.state === 'submitting';

  return (
    <>
      <Form method="post" className={classes.form}>
        <div className={classes.actions}>
        <span><h1>Create Vendor Account</h1></span>
        </div>
        {data && data.errors && (
          <ul>
            {Object.values(data.errors).map((error) => (
              <li className={classes.error} key={error}>{error}</li>
            ))}
          </ul>
        )}
        <p>
          <label htmlFor="vendor">Vendor</label>
          <input id="vendor" type="text" name="vendor" required />
        </p>
        <p>
          <label htmlFor="email">Email</label>
          <input id="email" type="email" name="email" required />
        </p>
        <p>
          <label htmlFor="image">Password</label>
          <input id="password" type="password" name="password" required />
        </p>
        <p>
          <label htmlFor="image">Verify Password</label>
          <input id="verify-password" type="password" name="verify-password" required />
        </p>
        <div className={classes.actions}>
          <button disabled={isSubmitting}>
            {isSubmitting ? 'Submitting...' : 'Create'}
          </button>
        </div>
      </Form>
    </>
  );
}

export default CreateAccount;
